import React, { useContext, useState } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Slider from 'rc-slider'
import Select from 'react-select'
import 'rc-slider/assets/index.css'
import Item from '../../inspect/components/tracker/item'
import TrackerTransition from '../../../../../images/tracker-transition.svg'
import { DashboardContext } from '../../../dashboard-context'

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    margin: '8px 0px',
  }),
  control: (provided, state) => ({
    ...provided,
    background: '#eaedf5',
    border: 'none',
    borderRadius: '100px',
    height: '40px',
    color: state.isSelected ? 'red' : 'blue',
    boxShadow: 'none',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    fontWeight: 'bold',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: '0px 16px'
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? '#d2ecda' : '#FFF',
    color: '#333333'
  }),
}

const FoodForm = (props) => {
  const { openSnackbar } = useContext(DashboardContext)
  const [sliderValue, updateSliderValue] = useState(null)
  const [servingStr, updateServingStr] = useState(null)
  const [nameStr, updateNameStr] = useState('')
  const [proteinStr, updateProteinStr] = useState('')
  const [carbsStr, updateCarbsStr] = useState('')
  const [fatStr, updateFatStr] = useState('')
  const [fiberStr, updateFiberStr] = useState('')
  const [customServingStr, updateCustomServingStr] = useState('')
  const [customUnit, updateCustomUnit] = useState(null)
  const [customUnitStr, updateCustomUnitStr] = useState('')
  const [unit, updateUnit] = useState(null)
  const [showUnitModal, updateShowUnitModal] = useState(false)
  const [caloriesStr, updateCaloriesStr] = useState('')

  const doReset = () => {
    updateSliderValue(null)
    updateServingStr(null)
    updateNameStr('')
    updateProteinStr('')
    updateCarbsStr('')
    updateFatStr('')
    updateFiberStr('')
    updateCustomServingStr('')
    updateCustomUnit(null)
    updateCustomUnitStr('')
    updateUnit(null)
    updateShowUnitModal(false)
    updateCaloriesStr('')
  }

  const handleClose = () => {
    doReset()
    props.onClose()
  }

  const updateServing = (val) => {
    props.updateFoodItem(new Item(Object.assign({}, props.foodItem, {serving: val})))
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  }

  const handleSliderChange = (value) => {
    const numericValue = Number(value)
    updateSliderValue(numericValue > 1 ? 1 : (numericValue < 0 ? 0 : numericValue))
  }

  const renderCustomFoodCalories = () => {
    let protein = Number(proteinStr)
    if (isNaN(protein)) {
      protein = 0
    }
    let carbs = Number(carbsStr)
    if (isNaN(carbs)) {
      carbs = 0
    }
    let fat = Number(fatStr)
    if (isNaN(fat)) {
      fat = 0
    }
    const calories = 4 * (protein + carbs) + 9 * fat
    return calories.toFixed(0)
  }

  const renderCustomItem = () => {
    const defaultUnit = props.itemType === 'alcohol' ? 'milliliters' : 'grams'
    const currentUnit = unit === null ? defaultUnit : unit
    let customOptions = [
      { value: defaultUnit, label: defaultUnit},
      { value: 'oz', label: 'ounces' }
    ]
    if(customUnit) {
      customOptions.push({ value: customUnit, label: customUnit})
    }
    customOptions.push({ value: 'custom', label: 'Custom Unit' })
    const currentCustomUnit = customOptions.filter(obj => obj.value === currentUnit)
    const currentSliderValue = sliderValue !== null ? sliderValue : 0.5

    const renderCustomFoodCarbs = () => {
      let result
      if (caloriesStr === '') {
        result = ''
      } else {
        const calories = Number(caloriesStr)
        if (isNaN(calories)) {
          result = ''
        } else {
          const carbs = calories * (1 - currentSliderValue) / 4
          result = carbs.toFixed(1)
        }
      }
      return result
    }

    const renderCustomFoodFat = () => {
      let result
      if (caloriesStr === '') {
        result = ''
      } else {
        const calories = Number(caloriesStr)
        if (isNaN(calories)) {
          result = ''
        } else {
          const fat = calories * currentSliderValue / 9
          result = fat.toFixed(1)
        }
      }
      return result
    }

    const handleSelectChange = (option) => {
      if (option.value === 'custom') {
        updateShowUnitModal(true)
      } else {
        updateUnit(option.value)
      }
    }

    const closeUnitModal = () => {
      updateShowUnitModal(false)
    }

    const handleUnitSubmit = () => {
      if (customUnitStr) {
        updateCustomUnit(customUnitStr)
        updateUnit(customUnitStr)
      }
      updateShowUnitModal(false)
    }

    const checkNonBlank = (value, label) => {
      let result

      if (value === '') {
        openSnackbar('Please enter a value for ' + label + '.', true)
        result = null
      } else {
        result = value
      }
      return result
    }

    const checkNumeric = (value, label) => {
      let result

      const n = checkNonBlank(value, label)
      if (n === null) {
        result = null
      } else {
        result = Number(n)
        if (isNaN(result)) {
          openSnackbar('Please enter a numeric value for ' + label + '.', true)
          result = null
        } else if (result < 0) {
          openSnackbar('Please enter a non-negative value for ' + label + '.', true)
          result = null
        }
      }
      return result
    }

    const handleCustomSubmit = () => {
      let data = { name: checkNonBlank(nameStr, 'Name') }
      if (data.name !== null) {
        let valid = false
        if (props.itemType === 'alcohol') {
          data.baseCalories = checkNumeric(caloriesStr, 'Calories')
          if (data.baseCalories !== null) {
            data.baseProtein = 0
            data.baseCarbs = data.baseCalories * (1 - currentSliderValue) / 4
            data.baseFat = data.baseCalories * currentSliderValue / 9
            data.baseFiber = 0
            valid = true
          }
        } else {
          data.baseProtein = checkNumeric(proteinStr, 'Protein')
          if (data.baseProtein !== null) {
            data.baseCarbs = checkNumeric(carbsStr, 'Carbs')
            if (data.baseCarbs !== null) {
              data.baseFat = checkNumeric(fatStr, 'Fat')
              if (data.baseFat !== null) {
                data.baseFiber = checkNumeric(fiberStr, 'Fiber')
                if (data.baseFiber !== null) {
                  data.baseCalories = 4 * (data.baseProtein + data.baseCarbs) + 9 * data.baseFat
                  valid = true
                }
              }
            }
          }
        }
        if (valid) {
          data.serving = checkNumeric(customServingStr, "Amount")
          if (data.serving !== null) {
            if (data.serving === 0) {
              openSnackbar('Please enter a positive value for Amount.', true)
            } else {
              data.baseUnit = currentUnit
              data.baseGrams = 0
              data.baseSize = data.serving
              data.itemType = props.itemType
              data.customServing = { servingWeightGrams: 1, unit: 'servings' }
              const newFoodItem = new Item(data)
              const newItem = Object.assign({}, newFoodItem)
              doReset()
              props.handleFoodFormSubmit(newItem)
            }
          }
        }
      }
    }

    return (
      <>
        <div>
          <div className="tracker-rebrand-form-header-dark">
            <div className="tracker-form-actions">
              <IconButton
                color="inherit"
                onClick={handleClose}
                aria-label="Close"
              >
                <Icon style={{color: '#FFFFFF'}}>arrow_back_ios_new</Icon>
              </IconButton>
              <div className="tracker-form-rebrand-actions">
              </div>
            </div>
            <div className="tracker-rebrand-header-transition" >
              <img src={TrackerTransition} alt="transition" />
            </div>
          </div>
        </div>
        <div className="tracker-overlay-form" >
          <input
            className="tracker-rebrand-form-input"
            placeholder="Name"
            value={nameStr}
            onChange={(e) => updateNameStr(e.target.value)}
            onKeyPress={handleKeyPress}
            margin="normal"
            variant="filled"
          />
          {props.itemType === 'alcohol' ? (
            <>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{width: '100%'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Calories"
                    value={caloriesStr}
                    onChange={(e) => updateCaloriesStr(e.target.value)}
                    onKeyPress={handleKeyPress}
                    type="number"
                  />
                </div>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <p className="tracker-rebrand-alcohol-macros">Carbs: {renderCustomFoodCarbs()}</p>
                <p className="tracker-rebrand-alcohol-macros">Fat: {renderCustomFoodFat()}</p>
              </div>
            </>
          ) : (
            <>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{width: '33%', padding: '0px 8px 0px 0px'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Protein"
                    value={proteinStr}
                    onChange={(e) => updateProteinStr(e.target.value)}
                    onKeyPress={handleKeyPress}
                    margin="normal"
                    variant="filled"
                    type="number"
                  />
                </div>
                <div style={{width: '33%', padding: '0px 4px'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Carbs"
                    value={carbsStr}
                    onChange={(e) => updateCarbsStr(e.target.value)}
                    onKeyPress={handleKeyPress}
                    margin="normal"
                    variant="filled"
                    type="number"
                  />
                </div>
                <div style={{width: '33%', padding: '0px 0px 0px 8px'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Fat"
                    value={fatStr}
                    onChange={(e) => updateFatStr(e.target.value)}
                    onKeyPress={handleKeyPress}
                    margin="normal"
                    variant="filled"
                    type="number"
                  />
                </div>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{width: '50%', padding: '0px 8px 0px 0px'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Fiber"
                    value={fiberStr}
                    onChange={(e) => updateFiberStr(e.target.value)}
                    onKeyPress={handleKeyPress}
                    margin="normal"
                    variant="filled"
                    type="number"
                  />
                </div>
                <div style={{width: '50%', padding: '0px 0px 0px 8px'}}>
                  <input
                    className="tracker-rebrand-form-input"
                    placeholder="Calories"
                    value={renderCustomFoodCalories()}
                    onKeyPress={handleKeyPress}
                    margin="normal"
                    variant="filled"
                    type="number"
                    disabled={true}
                  />
                </div>
              </div>
            </>
          )}
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{width: '50%', padding: '0px 8px 0px 0px'}}>
              <input
                className="tracker-rebrand-form-input"
                placeholder="Amount"
                value={customServingStr}
                onChange={(e) => updateCustomServingStr(e.target.value)}
                onKeyPress={handleKeyPress}
                margin="normal"
                type="number"
                variant="filled"
              />
            </div>
            <div style={{width: '50%', padding: '0px 0px 0px 8px'}}>
              <Select
                value={currentCustomUnit}
                onChange={handleSelectChange}
                styles={customStyles}
                options={customOptions}
              />
            </div>
          </div>
          {props.itemType === 'alcohol' && (
            <>
              <div className="tracker-rebrand-alcohol-slider-custom">
                <div>
                  <p>Carbs</p>
                  <p>{((1 - currentSliderValue) * 100).toFixed()}%</p>
                </div>
                <div>
                  <p style={{ textAlign: 'right' }}>Fat</p>
                  <p>{(currentSliderValue * 100).toFixed()}%</p>
                </div>
              </div>
              <div style={{ padding: '12px' }}>
                <Slider
                  defaultValue={currentSliderValue}
                  trackStyle={{ backgroundColor: '#519064', height: 6 }}
                  handleStyle={{
                    borderColor: 'transparent',
                    height: 26,
                    width: 26,
                    marginTop: -10,
                    backgroundColor: '#0ab23b',
                    opacity: 1,
                  }}
                  railStyle={{ backgroundColor: '#EEE', height: 6 }}
                  onChange={handleSliderChange}
                  min={0}
                  max={1}
                  step={0.01}
                />
              </div>
            </>
          )}
        </div>
        <button
          className="tracker-submit"
          variant="contained"
          color="primary"
          onClick={handleCustomSubmit}
        >
          Submit
        </button>
        <Dialog
          open={showUnitModal}
          onClose={closeUnitModal}
        >
          <DialogTitle id="alert-dialog-title">Custom Unit</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter a custom unit for this item.
            </DialogContentText>
            <TextField
              label="Custom Unit"
              value={customUnitStr}
              onChange={(e) => updateCustomUnitStr(e.target.value)}
              onKeyPress={handleKeyPress}
              margin="normal"
              variant="filled"
            />
          </DialogContent>
          <DialogActions>
            <Button
              className="tracker-custom-unit-submit"
              onClick={handleUnitSubmit}
            >
              Submit
            </Button>
            <Button
              className="tracker-custom-unit-submit close"
              onClick={closeUnitModal}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }

  const renderOtherItem = () => {
    let currentSliderValue
    if (sliderValue !== null) {
      currentSliderValue = sliderValue
    } else if (props.foodKind !== 'current' || props.foodItem.itemType !== 'alcohol' || props.foodItem.baseCalories === 0) {
      currentSliderValue = 0.5
    } else {
      currentSliderValue = Math.round(props.foodItem.baseFat * 900 / props.foodItem.baseCalories) / 100
    }

    let currentProtein
    let currentCarbs
    let currentFat
    let currentFiber
    let currentCalories
    if (props.foodItem.itemType === 'alcohol') {
      currentCalories = props.foodItem.getCalories()
      currentProtein = 0
      currentCarbs = currentCalories * (1 - currentSliderValue) / 4
      currentFat = currentCalories * currentSliderValue / 9
      currentFiber = 0
    } else {
      currentProtein = props.foodItem.getProtein()
      currentCarbs = props.foodItem.getCarbs()
      currentFat = props.foodItem.getFat()
      currentFiber = props.foodItem.getFiber()
      currentCalories = 4 * (currentProtein + currentCarbs) + 9 * currentFat
    }

    const currentRounding = props.foodItem.serving < 10 ? 100 : 10
    const currentServingStr = servingStr !== null ? servingStr : (Math.round(props.foodItem.serving * currentRounding) / currentRounding).toString()

    const handleSubmit = () => {
      let newItem = Object.assign({}, props.foodItem)
      if (props.foodItem.itemType === 'alcohol') {
        const currentCalories = newItem.baseCalories
        const currentCarbs = currentCalories * (1 - currentSliderValue) / 4
        const currentCarbsRounding = currentCarbs < 10 ? 100 : 10
        const currentFat = currentCalories * currentSliderValue / 9
        const currentFatRounding = currentFat < 10 ? 100 : 10
        newItem.baseCarbs = Math.round(currentCarbs * currentCarbsRounding) / currentCarbsRounding
        newItem.baseFat = Math.round(currentFat * currentFatRounding) / currentFatRounding
      }
      doReset()
      props.handleFoodFormSubmit(newItem)
    }

    const handleIncrement = () => {
      if (servingStr === null) {
        updateServing(props.foodItem.serving + 1)
      } else {
        updateServing(Number(currentServingStr) + 1)
        updateServingStr(null)
      }
    }

    const handleDecrement = () => {
      if (servingStr === null) {
        if (props.foodItem.serving > 1) {
          updateServing(props.foodItem.serving - 1)
        }
      } else {
        const effectiveCurrentServing = Number(currentServingStr)
        if (effectiveCurrentServing > 1) {
          updateServing(effectiveCurrentServing - 1)
          updateServingStr(null)
        }
      }
    }

    const handleInput = (val) => {
      updateServing(Number(val))
      updateServingStr(val)
    }

    const handleServingBlur = () => {
      updateServing(Number(currentServingStr))
      updateServingStr(null)
    }

    const getConversionFactor = (u) => {
      let factor = null
      if (u === props.foodItem.customServing.unit) {
        factor = Number(props.foodItem.customServing.servingWeightGrams) / props.foodItem.baseSize
      } else if (u === 'g' || u === 'grams') {
        factor = 1
      } else if (u === 'oz' || u === 'ounces') {
        factor = 28.3495
      }
      return factor
    }

    const handleUnitSelect = (val) => {
      const oldFactor = getConversionFactor(props.foodItem.unit)
      const newFactor = getConversionFactor(val)
      if (oldFactor && newFactor) {
        const effectiveCurrentServing = servingStr === null ? props.foodItem.serving : Number(currentServingStr)
        const newServing = effectiveCurrentServing * oldFactor / newFactor
        props.updateFoodItem(new Item(Object.assign({}, props.foodItem, {serving: newServing, unit: val})))
        updateServingStr(null)
      }
    }

    const handleEditCustomServing = () => {
    }

    return (
      <>
        <div>
          <div className="tracker-rebrand-form-header-dark">
            <div className="tracker-form-actions">
              <IconButton
                color="inherit"
                onClick={handleClose}
                aria-label="Close"
              >
                <Icon style={{color: '#FFFFFF'}}>arrow_back_ios_new</Icon>
              </IconButton>
              <div className="tracker-form-rebrand-actions">
                {props.foodKind === 'current' && (
                  <IconButton
                    onClick={props.handleQuickDelete}
                    aria-label="Delete Item"
                  >
                    <Icon style={{ color: '#FFF' }}>delete_forever</Icon>
                  </IconButton>
                )}
              </div>
            </div>
            <p className="tracker-rebrand-header-name">{props.foodItem.name}</p>
            <div className="tracker-rebrand-header-macros">
              {props.foodItem.itemType !== 'alcohol' && (
                <p>Protein: <span>{currentProtein.toFixed(1)}g</span></p>
              )}
              <p>Carbs: <span>{currentCarbs.toFixed(1)}g</span></p>
              <p>Fat: <span>{currentFat.toFixed(1)}g</span></p>
              <p>Calories <span>{currentCalories.toFixed(0)}</span></p>
              {props.foodItem.itemType !== 'alcohol' && (
                <p>Fiber: <span>{currentFiber.toFixed(1)}</span></p>
              )}
            </div>
            {props.foodItem.itemType === 'alcohol' && (
              <>
                <div className="tracker-rebrand-alcohol-slider-custom" style={{color: '#FFF'}}>
                  <div>
                    <p>Carbs</p>
                    <p>{((1 - currentSliderValue) * 100).toFixed()}%</p>
                  </div>
                  <div>
                    <p style={{ textAlign: 'right' }}>Fat</p>
                    <p>{(currentSliderValue * 100).toFixed()}%</p>
                  </div>
                </div>
                <div style={{ padding: '12px 24px 36px 24px' }}>
                  <Slider
                    defaultValue={currentSliderValue}
                    trackStyle={{ backgroundColor: '#bbbbbb', height: 6 }}
                    handleStyle={{
                      borderColor: 'transparent',
                      height: 26,
                      width: 26,
                      marginTop: -10,
                      backgroundColor: '#0ab23b',
                      opacity: 1,
                    }}
                    railStyle={{ backgroundColor: '#404040', height: 6 }}
                    onChange={handleSliderChange}
                    min={0}
                    max={1}
                    step={0.01}
                  />
                </div>
              </>
            )}
            <div className="tracker-rebrand-header-transition" >
              <img src={TrackerTransition} alt="transition" />
            </div>
          </div>
        </div>
        <div className="tracker-overlay-form" >
          <p className="tracker-rebrand-edit-text">How much did you have?</p>
          <div style={{width: '100%', margin: '0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <button className="tracker-rebrand-edit-increment" onClick={handleDecrement}>
              <span>-</span>
            </button>
            <div style={{position: 'relative'}}>
              <input
                className="tracker-rebrand-edit-input"
                placeholder="0"
                value={currentServingStr}
                onChange={(e) => handleInput(e.target.value)}
                onBlur={handleServingBlur}
                onKeyPress={handleKeyPress}
                margin="normal"
                type="number"
                variant="filled"
              />
            </div>
            <button className="tracker-rebrand-edit-increment" onClick={handleIncrement}>
              <span>+</span>
            </button>
          </div>
          <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'nowrap', margin: '8px 0px'}}>
            <button
              className={props.foodItem.unit === props.foodItem.customServing.unit ? 'tracker-rebrand-form-input-unit active' : 'tracker-rebrand-form-input-unit'}
              onClick={() => handleUnitSelect(props.foodItem.customServing.unit)}
            >
              {props.foodItem.customServing.unit}
            </button>
            <button
              className={(props.foodItem.unit === 'g' || props.foodItem.unit === 'grams') ? 'tracker-rebrand-form-input-unit active' : 'tracker-rebrand-form-input-unit'}
              onClick={() => handleUnitSelect('grams')}
            >
              Grams
            </button>
            <button
              className={(props.foodItem.unit === 'oz' || props.foodItem.unit === 'ounces') ? 'tracker-rebrand-form-input-unit active' : 'tracker-rebrand-form-input-unit'}
              onClick={() => handleUnitSelect('ounces')}
            >
              Ounces
            </button>
          </div>
          <div style={{display: 'flex', justifyContent: 'center', margin: '8px 0px'}}>
            {props.foodItem.baseGrams !== 0 && props.foodItem.unit === props.foodItem.customServing.unit && (
              <button
                className="tracker-rebrand-edit-custom-text"
                onClick={handleEditCustomServing}
              >
                {props.foodItem.baseSize} {props.foodItem.customServing.unit} = {Number(props.foodItem.customServing.servingWeightGrams).toFixed(1)}g / {(Number(props.foodItem.customServing.servingWeightGrams) / 28.3495).toFixed(2)}oz
                <span style={{fontWeight: 'bold', marginLeft: '8px'}}>
                  Edit
                </span>
              </button>
            )}
          </div>
        </div>
        <button
          className="tracker-save"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          {props.foodKind === 'current' ? 'Save' : 'Add Item'}
        </button>
      </>
    )
  }

  return (
    <Dialog
      className="tracker-fullscreen-dialog"
      open={props.open}
      onClose={handleClose}
      fullScreen
    >
      {props.open &&
        (props.foodLoading ? (
          <CircularProgress size={32} />
        ) : (props.foodKind === 'custom' ? renderCustomItem() : renderOtherItem()))}
    </Dialog>
  )
}

export default FoodForm